/**
 * Version du barème. Toute modification d'une valeur normative de
 * docs/SCORING.md change les scores de tous les utilisateurs et invalide les
 * comparaisons historiques : incrémenter ici et stocker la version avec chaque
 * résultat.
 */
export const scoringVersion = "1.3.0";
